/**
 * HappyDiertjes – Quick Add to Cart
 * Minimal AJAX cart handler for single-variant products in the collection grid.
 */

(function () {
  'use strict';

  function initHdQuickAdd() {
    document.querySelectorAll('[data-hd-cart-add]').forEach(function (btn) {
      if (btn.dataset.hdInitialized) return;
      btn.dataset.hdInitialized = 'true';

      btn.addEventListener('click', async function (e) {
        e.preventDefault();

        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        btn.classList.add('hd-card__cart-btn--loading');

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });

          if (!response.ok) throw new Error('Cart add failed');

          // Refresh cart count via Dawn's pub/sub or cart sections API
          const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
          const cart = await cartResponse.json();
          updateCartCount(cart.item_count);

          // Trigger Dawn's native cart refresh if available
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { cart: cart });
          } else {
            // Fallback: update cart bubble via Sections API
            refreshCartDrawer();
          }

          // Show success state
          btn.classList.remove('hd-card__cart-btn--loading');
          btn.classList.add('hd-card__cart-btn--added');
          setTimeout(function () {
            btn.classList.remove('hd-card__cart-btn--added');
          }, 1500);

        } catch (err) {
          btn.classList.remove('hd-card__cart-btn--loading');
          console.error('HD Quick Add error:', err);
        }
      });
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count], .cart-count-bubble span:first-child, #CartCount').forEach(function (el) {
      el.textContent = count;
    });

    // Dawn's cart bubble visibility
    const bubbles = document.querySelectorAll('.cart-count-bubble');
    bubbles.forEach(function (bubble) {
      if (count > 0) {
        bubble.removeAttribute('hidden');
        bubble.setAttribute('aria-hidden', 'false');
      }
    });
  }

  function refreshCartDrawer() {
    const sections = document.querySelector('cart-notification, cart-drawer');
    if (sections && typeof sections.renderContents === 'function') {
      fetch(window.Shopify.routes.root + '?sections=cart-notification,cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data['cart-notification']) {
            const notif = document.querySelector('cart-notification');
            if (notif) notif.renderContents({ sections: data });
          }
        })
        .catch(function () {});
    }
  }

  // Init on DOM ready and after dynamic section loads (filtering/pagination)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHdQuickAdd);
  } else {
    initHdQuickAdd();
  }

  // Re-init after Shopify section re-renders (pagination, filtering)
  document.addEventListener('shopify:section:load', initHdQuickAdd);

  // Re-init after facet/filter updates (Dawn dispatches this)
  document.addEventListener('DOMContentLoaded', function () {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1 && node.querySelectorAll) {
              node.querySelectorAll('[data-hd-cart-add]').forEach(function (btn) {
                if (!btn.dataset.hdInitialized) initHdQuickAdd();
              });
            }
          });
        }
      });
    });

    const grid = document.getElementById('ProductGridContainer');
    if (grid) {
      observer.observe(grid, { childList: true, subtree: true });
    }
  });
})();
